import React, { useCallback, useEffect, useState } from 'react';
import { Modal, Row, Col, Tag } from 'antd';
import CONSTANT from '../../../config/constant';
import { axiosInstance } from '../../../config/api';
import moment from 'moment';
const arrStatus = {
    'wait_paid': { text: "Chờ thanh toán", color: "orange" },
    'paid': { text: 'Đã thanh toán', color: 'green' },
    'confirmed': { text: 'Đã xác nhận', color: 'blue' },
    'agency_begin': { text: 'Bạn đã xác nhận bắt đầu', color: 'orange' },
    'begin': { text: 'Khách đã xác nhận bắt đầu', color: 'green' },
    'agency_completed': { text: 'Bạn đã xác nhận hoàn thành', color: 'green' },
    'completed': { text: 'Khách xác nhận hoàn thành', color: 'green' },
    'abandoned': { text: 'Khách đã hủy', color: 'red' },
    'cancelled': { text: 'Bạn đã hủy tour này', color: 'red' },
    'refunded': { text: 'Đã hoàn hoàn tiền', color: 'orange' },
};
const ModalInfoOrderService = (props) => {    
    const [order, setOrder] = useState(null);
    const [loading, setLoading] = useState(false);
    const handleCancel = useCallback(() => {
        props.cancel();
    }, [props.data]);
    useEffect(() => {
        loadOrder();
    }, [props.orderId]);
    // load Agency    
    const loadOrder = async () => {
        setLoading(true);
        if (props && props.orderId) {
            await axiosInstance.get(`${CONSTANT.API.DOCTOR.ORDER}/${props.orderId}`)
                .then(async res => {
                    if (res && res.data && res.data.code === 200) {
                        setOrder(res.data.data)
                    }
                })
        }
        setLoading(false);
    }
    return (
        <Modal title="Thông tin đặt dịch vụ"
            visible={props.visible}
            onOk={handleCancel}
            onCancel={handleCancel}
            cancelText="Hủy"
            okText="Đóng"
            className="modal-book-facility"
            centered
            cancelButtonProps={{ className: "btn-global bg btn-cancel" }}
            okButtonProps={{ className: "btn-global bg" }}
            width={800}
            //cancelButtonProps={{ style: { display: 'none' } }}
        >
            {
                order && <Row gutter={24}>
                    <Col xs={12} md={5} style={{ fontWeight: 'bold', paddingBottom: '15px' }}>
                       Họ tên người đặt:
                    </Col>
                    <Col xs={12} md={7}>
                        {order.contact.fullname_orderer}
                    </Col>                    
                    <Col xs={12} md={5} style={{ fontWeight: 'bold', paddingBottom: '15px' }}>
                        Họ tên người khám: 
                    </Col>
                    <Col xs={12} md={7}>
                        {order.contact.fullname_orderer}
                    </Col>
                    <Col xs={12} md={5} style={{ fontWeight: 'bold', paddingBottom: '15px' }}>
                        Email người đặt:
                    </Col>
                    <Col xs={12} md={7}>
                        {order.contact.email}
                    </Col> 
                    <Col xs={12} md={5} style={{ fontWeight: 'bold', paddingBottom: '15px' }}>
                        Đ.Thoại người đặt:
                    </Col>
                    <Col xs={12} md={7}>
                        {'+'+order.contact.dial_code+order.contact.phone}
                    </Col> 
                    <Col xs={12} md={5} style={{ fontWeight: 'bold', paddingBottom: '15px' }}>
                        Ngày đặt hẹn:
                    </Col>
                    <Col xs={12} md={7}>
                        {`${moment(new Date(order.created_at)).format('DD/MM/YYYY HH:mm')}`}
                    </Col> 
                    <Col xs={12} md={5} style={{ fontWeight: 'bold', paddingBottom: '15px' }}>
                        Thời gian hẹn:
                    </Col>
                    <Col xs={12} md={7}>
                        {order.date&&order.date.day_of_week && 'Thứ ' + (order.date?.day_of_week + 1) + ' - ' + (order.date?.day) + '/' + (order.date?.month) + '/' + (order.date?.year) + '  ' + (order.time?.time_h) + ':' + (order.time?.time_m)}
                    </Col>                   
                    <Col xs={12} md={5} style={{ fontWeight: 'bold', paddingBottom: '15px' }}>
                        Tên dịch vụ: 
                    </Col>
                    <Col xs={12} md={7}>
                        {order.items && order.items.length > 0 && order.items[0].service.name}
                    </Col> 
                    <Col xs={12} md={5} style={{ fontWeight: 'bold', paddingBottom: '15px' }}>
                        Thời gian thực hiện: 
                    </Col>
                    <Col xs={12} md={7}>
                        {order.items && order.items.length > 0 && order.items[0].service?.duration + ' phút'}
                    </Col>
                    <Col xs={12} md={5} style={{ fontWeight: 'bold', paddingBottom: '15px' }}>
                        Giá dịch vụ: 
                    </Col>
                    <Col xs={12} md={7}>
                        {order.items && order.items.length > 0 && order.items[0].price.toLocaleString('en-US') +' ₫'}
                    </Col>
                    <Col xs={12} md={5} style={{ fontWeight: 'bold', paddingBottom: '15px' }}>
                        Trạng thái: 
                    </Col>
                    <Col xs={12} md={7}>
                    {(order.status && arrStatus[order.status]) ? <Tag color={arrStatus[order.status].color}>{arrStatus[order.status].text}</Tag>:<Tag color='black'>Rác</Tag>}
                    </Col>
                </Row>
            }

        </Modal>
    )
}
export default ModalInfoOrderService;